// @flow
import React from 'react';
import classnames from 'classnames';

import Image from 'Components/frameworks/image/Image.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import { themes } from './Avatar.themes';

export type AvatarProps = {
  className?: string,
  size?: number,
  theme?: string,
  userDescription?: string,
  userName?: string,
  userPictureUrl?: string,
};

export function Avatar(props: AvatarProps) {
  const {
    className,
    size = 35,
    theme = 'default',
    userDescription,
    userName,
    userPictureUrl,
  } = props;

  if (!userPictureUrl && !userName) return null;

  const styles = { width: size, height: size };
  const imageSize = {
    w: size,
    h: size,
  };

  const { thDescription, thName, thPicture, thRoot, thTexts, thTextTheme } = themes[theme];

  return (
    <div className={classnames(className, thRoot)}>
      {userPictureUrl && (
        <div className={thPicture} data-testid="Avatar-picture" style={styles}>
          <Image
            altMsg={userName}
            forceImage
            imageUrl={userPictureUrl}
            mandatoryWidthAndHeight={imageSize}
          />
        </div>
      )}
      {(!!userName || !!userDescription) && (
        <div className={thTexts}>
          {!!userName && (
            <div className={thName} data-testid="Avatar-name">
              {userName}
            </div>
          )}
          {!!userDescription && (
            <Text className={thDescription} text={userDescription} theme={thTextTheme} />
          )}
        </div>
      )}
    </div>
  );
}
